import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2318cc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hb-title" }, "Help build a Hunt", -1 /* HOISTED */))
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 1,
  class: "nge-hb-id"
}
const _hoisted_4 = {
  key: 0,
  class: "nge-hb-steps"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<li data-v-e2318cc1>Press <b data-v-e2318cc1>Cut</b> or <b data-v-e2318cc1>Merge</b> in the tool bar, as you normally would.</li><li data-v-e2318cc1>Ctrl + click to place your points.</li><li data-v-e2318cc1>Press <b data-v-e2318cc1>Submit cut / merge</b> below (or Submit in the tool bar). Pyr checks it would work and puts it in your list. The cell does not change.</li><li data-v-e2318cc1>When you are done, press <b data-v-e2318cc1>Send to the admins</b>.</li>", 4)
const _hoisted_9 = [
  _hoisted_5
]
const _hoisted_10 = {
  key: 1,
  class: "nge-hb-muted"
}
const _hoisted_11 = {
  key: 2,
  class: "nge-hb-hint"
}
const _hoisted_12 = { class: "nge-hb-btnrow" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "nge-hb-counts" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Merges", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cuts", -1 /* HOISTED */))
const _hoisted_18 = {
  key: 3,
  class: "nge-hb-win",
  role: "status"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "nge-hb-wintitle" }, "Sent!", -1 /* HOISTED */))
const _hoisted_21 = { class: "nge-hb-wintext" }
const _hoisted_22 = {
  key: 5,
  class: "nge-hb-list"
}
const _hoisted_23 = { class: "nge-hb-what" }
const _hoisted_24 = { class: "nge-hb-sub" }
const _hoisted_25 = { class: "nge-hb-acts" }
const _hoisted_26 = ["disabled", "title", "onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = {
  key: 0,
  class: "nge-hb-noterow"
}
const _hoisted_30 = ["onKeydown"]
const _hoisted_31 = ["disabled", "onClick"]
const _hoisted_32 = {
  key: 6,
  class: "nge-hb-muted"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 1,
  class: "nge-hb-error",
  role: "alert"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.buildState.helping && $setup.buildState.mine.length)
    ? (_openBlock(), _createElementBlock("aside", {
        key: 0,
        ref: "boxEl",
        class: _normalizeClass(["nge-hb", { 'nge-hb--dragging': $setup.dragging }]),
        style: _normalizeStyle($setup.posStyle),
        role: "dialog",
        "aria-label": "Help build a Hunt"
      }, [
        _createElementVNode("div", {
          class: "nge-hb-head",
          title: "Drag to move",
          onPointerdown: _cache[1] || (_cache[1] = (...args) => ($setup.startDrag && $setup.startDrag(...args)))
        }, [
          _hoisted_1,
          ($setup.buildState.mine.length > 1)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.pick) = $event)),
                class: "nge-hb-pick",
                "aria-label": "Which cell"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.buildState.mine, (c, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: c.id,
                    value: i
                  }, "Cell …" + _toDisplayString(c.root.slice(-6)), 9 /* TEXT, PROPS */, _hoisted_2))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */)), [
                [
                  _vModelSelect,
                  $setup.pick,
                  void 0,
                  { number: true }
                ]
              ])
            : ($setup.cell)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Cell …" + _toDisplayString($setup.cell.root.slice(-6)), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: "nge-hb-x",
            "aria-label": "Close",
            onClick: $setup.close
          }, "×")
        ], 32 /* HYDRATE_EVENTS */),
        ($setup.cell)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createCommentVNode(" Each step spelled out (Ames 2026-10-27: \"am I supposed to hit submit cut? instructions unclear\") "),
              ($setup.cell.open)
                ? (_openBlock(), _createElementBlock("ol", _hoisted_4, _hoisted_9))
                : _createCommentVNode("v-if", true),
              ($setup.cell.open)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                    _createTextVNode("Where yours go stays a secret until the Hunt."),
                    ($setup.cell.closes)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" Open until " + _toDisplayString($setup.closesLine) + ".", 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, "Suggestions for this cell have closed. Thanks for helping! The admins are looking at them now.")),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "nge-hb-btn nge-hb-btn--open",
                  disabled: !!$setup.busy,
                  onClick: $setup.open
                }, _toDisplayString($setup.busy === 'open' ? 'Opening…' : $setup.here ? 'Show the cell' : 'Open the cell on the Sandbox'), 9 /* TEXT, PROPS */, _hoisted_13),
                ($setup.cell.open)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "nge-hb-btn nge-hb-btn--submit",
                      disabled: !!$setup.busy,
                      title: "Saves the cut or merge you are making as your suggestion. Nothing in the cell changes.",
                      onClick: $setup.submitHere
                    }, "Submit cut / merge", 8 /* PROPS */, _hoisted_14))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", null, [
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString($setup.cell.used.merge) + " of " + _toDisplayString($setup.cell.merges_each) + " ", 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cell.merges_each, (n) => {
                    return (_openBlock(), _createElementBlock("i", {
                      key: `m${n}`,
                      class: _normalizeClass(["nge-hb-pip", { 'nge-hb-pip--merge': n <= $setup.cell.used.merge }])
                    }, null, 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("span", null, [
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString($setup.cell.used.cut) + " of " + _toDisplayString($setup.cell.cuts_each) + " ", 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cell.cuts_each, (n) => {
                    return (_openBlock(), _createElementBlock("i", {
                      key: `c${n}`,
                      class: _normalizeClass(["nge-hb-pip", { 'nge-hb-pip--cut': n <= $setup.cell.used.cut }])
                    }, null, 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              ($setup.sentNow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("img", {
                      class: "nge-hb-reaper",
                      src: $setup.reaperIcon,
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_19),
                    _createElementVNode("div", null, [
                      _hoisted_20,
                      _createElementVNode("span", _hoisted_21, _toDisplayString($setup.sentNow) + " " + _toDisplayString($setup.sentNow === 1 ? 'suggestion is' : 'suggestions are') + " with the admins. You hear in the bell when one is planted, and every helper with a planted one gets an Achievement when the Hunt ends.", 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.buildState.last)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 4,
                    class: _normalizeClass(["nge-hb-last", { 'nge-hb-last--bad': !$setup.buildState.lastOk }]),
                    role: "status"
                  }, _toDisplayString($setup.buildState.last), 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.cell.suggestions.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cell.suggestions, (s) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: s.id,
                        class: "nge-hb-row"
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["nge-hb-dot", `nge-hb-dot--${s.kind}`])
                        }, null, 2 /* CLASS */),
                        _createElementVNode("span", _hoisted_23, [
                          _createElementVNode("b", null, _toDisplayString($setup.kindWord(s)), 1 /* TEXT */),
                          _createTextVNode(),
                          _createElementVNode("span", _hoisted_24, "· " + _toDisplayString(s.note || $setup.detail(s)), 1 /* TEXT */),
                          ($setup.statusWord(s))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["nge-hb-st", { 'nge-hb-st--ok': s.status === 'planted' }])
                              }, _toDisplayString($setup.statusWord(s)), 3 /* TEXT, CLASS */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("span", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "nge-hb-link",
                            disabled: !$setup.here,
                            title: $setup.here ? 'Go to it' : 'Open the cell first',
                            onClick: $event => ($setup.goToNm(s.at))
                          }, "Go there", 8 /* PROPS */, _hoisted_26),
                          ((s.status === 'draft' || s.status === 'open') && $setup.cell.open)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  class: "nge-hb-link",
                                  onClick: $event => ($setup.startNote(s))
                                }, "Note", 8 /* PROPS */, _hoisted_27),
                                _createElementVNode("button", {
                                  class: "nge-hb-link",
                                  disabled: !!$setup.busy,
                                  onClick: $event => ($setup.takeBack(s))
                                }, _toDisplayString($setup.busy === `back${s.id}` ? 'Taking back…' : 'Take back'), 9 /* TEXT, PROPS */, _hoisted_28)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        ($setup.noteFor === s.id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.noteText) = $event)),
                                class: "nge-hb-note",
                                maxlength: "300",
                                placeholder: "Why this one is a good Hunt error",
                                "aria-label": "A note for the admins",
                                onKeydown: _withKeys($event => ($setup.saveNote(s)), ["enter"])
                              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_30), [
                                [_vModelText, $setup.noteText]
                              ]),
                              _createElementVNode("button", {
                                class: "nge-hb-btn nge-hb-btn--small",
                                disabled: !!$setup.busy,
                                onClick: $event => ($setup.saveNote(s))
                              }, "Save", 8 /* PROPS */, _hoisted_31)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_32, "No suggestions yet. Find a spot where a merger or a missing piece would fool a hunter.")),
              ($setup.cell.open && $setup.drafts.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 7,
                    class: "nge-hb-btn nge-hb-btn--send",
                    disabled: !!$setup.busy,
                    onClick: $setup.sendAll
                  }, _toDisplayString($setup.busy === 'send' ? 'Sending…' : `Send to the admins (${$setup.drafts.length})`), 9 /* TEXT, PROPS */, _hoisted_33))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($setup.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString($setup.error), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ], 6 /* CLASS, STYLE */))
    : _createCommentVNode("v-if", true)
}